import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { createContext, useContext, useEffect, useState } from "react";
import { env, ROLE } from "resume-builder-v2-common";
export var SessionContext = /*#__PURE__*/createContext(null);
export var WithSessionContext = function WithSessionContext(_ref) {
  var children = _ref.children;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      sessionUser = _useState2[0],
      setSessionUser = _useState2[1];

  var userId = sessionUser === null || sessionUser === void 0 ? void 0 : sessionUser.id;
  useEffect(function () {
    var timeout;

    var checkSessionState = function checkSessionState() {
      fetch("".concat(env.api, "/v1/session"), {
        credentials: "include",
        mode: "cors"
      }).then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
          var responseData;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return response.json();

                case 2:
                  responseData = _context.sent;

                  if (responseData === false) {
                    if (userId) {
                      setSessionUser(null);
                    }
                  } else {
                    if (responseData.id !== userId) {
                      setSessionUser(responseData);
                    }
                  }

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }())["catch"](function (err) {
        console.error(err);
      })["finally"](function () {
        timeout = setTimeout(function () {
          checkSessionState();
        }, 10000);
      });
    };

    checkSessionState();
    return function () {
      clearTimeout(timeout);
    };
  }, [userId, setSessionUser]);
  return /*#__PURE__*/React.createElement(SessionContext.Provider, {
    value: sessionUser
  }, children);
};
export var AuthenticatedOnly = function AuthenticatedOnly(_ref3) {
  var children = _ref3.children;
  var context = useSessionContext();
  if (context === null) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
export var AdminOnly = function AdminOnly(_ref4) {
  var children = _ref4.children;
  var context = useSessionContext();
  if (context === null) return null;
  if (context.role !== ROLE.Admin) return null;
  return children;
};
export var useSessionContext = function useSessionContext() {
  var context = useContext(SessionContext);
  return context;
};